import React from 'react';

const EditIcon = () => (
  <svg width={16} height={16} viewBox="0 0 16 16" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.497 2.32L13.71.503a1.72 1.72 0 00-2.43 0L2.413 9.335A1.754 1.754 0 002 10.01L0 16l5.995-2c.251-.087.48-.228.67-.413l8.832-8.837a1.72 1.72 0 000-2.43zM3.462 9.93l5.014-5.008.906.905-5.032 5.015-.888-.911zm5.8-5.822l.91-.906 2.626 2.625-.906.911-2.63-2.63zm-6.385 6.889l2.132 2.126-3.192 1.06 1.06-3.186zm3.192 1.564l-.91-.911 5.014-5.009.905.905-5.009 5.015zm8.597-8.597L13.59 5.042 10.98 2.388l1.077-1.077a.573.573 0 01.407-.166c.153-.001.3.059.407.166l1.817 1.822a.573.573 0 010 .809l-.023.022z"
      fill="#335267"
    />
  </svg>
);

export default EditIcon;
